<!-- 恢复 给老新品用 -->
<template>
  <div class="reportTemplate">
    <p class="lable-left"><span><i class="el-icon-menu"></i>出厂检验报告模板</span></p>
    
    <table  cellspacing=0 >
       <colgroup>
        <col width="7%"/>
        <col width="15%"/>
        <col width="23%"/>
        <col  width="23%"/>
        <col  width="10%"/>
        <col width="10%"/>
        <col width="6%"/>
        <col width="6%"/>
        </colgroup>
      <thead>
         
        <tr>
          <td colspan="5" rowspan="2"><p class="lable-header">出厂检验报告模板</p></td>
          <td colspan="3">{{materData.version}}</td>
        </tr>
        <tr>
          <td colspan="3" class="title"><span class="verSIon" @click="goHistory()">历史版本</span></td>
        </tr>

        <tr>
          <td colspan="2" class="title">专用号</td>
          <td ><el-input placeholder="请输入专用号" v-model="materData.mtlNo" readonly></el-input></td>
          <td colspan="1">物料名称</td>
          <td colspan="4"><el-input placeholder="物料名称" v-model="materData.mtlName" readonly></el-input></td>
        </tr>
        <tr v-show="oldMatData.sysSource">
          <td colspan="2" class="title">工厂</td>
          <td ><el-input placeholder="工厂" v-model="oldMatData.createFactory" readonly></el-input></td>
          <td colspan="1">供应商编码</td>
          <td colspan="4"><el-input placeholder="供应商编码" v-model="oldMatData.oldSupplyCode" readonly></el-input></td>
        </tr>
        <tr>
          <td ><span style="line-height:30px">序号</span></td>
          <td>检验项目</td>
          <td colspan="2">技术（标准）要求</td>
          <td>重要性</td>
          <td>检查水平</td>
          <td>AQL</td>
          <td >操作</td>
        </tr>
      </thead>
      <tbody>
        <!-- templateId:"通用要求",
        templateCode:"Q/HR 0801001-2020",
        templateName:"家用电器电子控制板通用要求",
        itemList:[
          {
            itemId:"",
            itemName:"外观",
            remark:"外观",
            importanceProperty:"重要性",
            checkLevel:"检查水平",
            aqlProperty:"aql",
          }, -->
         <template v-for="(item,index) in list"  :key="item.templateId">
            <tr><td class="title" colspan="8">标准编号:<span>{{item.templateCode}}</span>标准名称:<span>{{item.templateName}}</span>
            <div v-show="!editFalg">
              <el-button  size="mini" type="warning" @click="addStandard(index,'list')">新增</el-button>
               <el-popconfirm
                  title="确定删除吗？" @confirm=" deleteStandard('parent',index,'list')"
                > <template #reference><el-button size="mini" >删除</el-button></template>
                </el-popconfirm>
            </div>
            </td></tr>
            <tr v-for="(child, childIndex) in item.itemList" :key="child.itemId">
              <td>{{childIndex+1}}</td>
              <td>
                <el-input  v-if="!editFalg" v-model="child.itemName" :readonly="editFalg"  type="textarea" :rows="1" placeholder="请输入内容" ></el-input>
                <span v-else style="float: left;text-align:left">{{child.itemName}}</span>
              </td> 
              <td colspan="2"><el-input v-if="!editFalg" type="textarea" :readonly="editFalg" :rows="1" placeholder="请输入内容" v-model="child.remark"></el-input>
                <span v-else style="float: left;text-align:left;padding:5px">{{child.remark}}</span>
              </td>
              <td>
                <el-select :disabled="(dataFrom =='sqm' &&  child.isSupply == 'N') || editFalg" v-model="child.importanceProperty" placeholder="请选择">
                      <el-option v-for="optionKey in importancePropertyList" :key="optionKey.valueId" :label="optionKey.valueName" :value="optionKey.valueId+''"></el-option>
                  </el-select>
                <!-- <el-input v-model="child.importanceProperty"  type="textarea" :rows="1" placeholder="请输入内容" ></el-input> -->
              
              </td>
              <td>
                 <el-select :disabled="(dataFrom =='sqm' &&  child.isSupply == 'N') || editFalg"  v-model="child.checkLevel" placeholder="请选择">
                      <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId" :label="optionKey.valueName" :value="optionKey.valueId+''"></el-option>
                  </el-select>
                <!-- <el-input v-model="child.checkLevel"   placeholder="请输入内容" ></el-input> -->
              </td>
              <td><el-input v-model="child.aqlProperty"  :disabled="(dataFrom =='sqm' &&  child.isSupply == 'N') || editFalg" placeholder="请输入内容" ></el-input></td>
              <td v-if="!editFalg"> <span v-show="!(dataFrom =='sqm' &&  child.isSupply == 'N')">
                <el-popconfirm 
                  title="确定删除吗？" @confirm=" deleteStandard('child',index,'list',childIndex)"
                ><template #reference> <i class="el-icon-delete"></i> </template></el-popconfirm>
              </span>
                <i class="el-icon-circle-plus-outline" @click="deleteStandard('add',index,'list',childIndex)"></i>
                </td>
                 <td v-else></td>
            </tr>
        </template>
        <!-- 通用要求 -->
        <!-- templateId:"通用要求",
        templateCode:"Q/HR 0801001-2020",
        templateName:"家用电器电子控制板通用要求",
        child:[
          {
            itemId:"",
            itemName:"外观",
            remark:"外观",
            importanceProperty:"重要性",
            checkLevel:"检查水平",
            aqlProperty:"aql",
          }, -->
        
        <template v-for="(item,index) in commentList"  :key="item.templateId">
            <tr><td class="title" colspan="8">{{item.templateName}}
            <div>
              <!-- <el-button size="mini" type="primary" @click="addStandard(index,'commentList')">新增</el-button> -->
            </div>
            </td></tr>
            <tr v-for="(child, childIndex) in item.itemList" :key="child.itemId">
              <td>{{childIndex+1}}</td>
              <td>
                <el-input v-if="!editFalg"  type="textarea" v-model="child.itemName" :readonly="child.isMust == 'Y'" :rows="1" placeholder="请输入内容"></el-input>
                <span v-else style="float: left;text-align:left">{{child.itemName}}</span>
              </td>
              <td colspan="2">
                <el-input v-if="!editFalg" :readonly="editFalg" type="textarea" v-model="child.remark" :rows="1" placeholder="请输入内容"></el-input>
                <span v-else style="float: left;text-align:left">{{child.remark}}</span>
              </td>

              <td>
                <!-- <el-input type="textarea" v-model="child.importanceProperty" :rows="1" placeholder="请输入内容"></el-input> -->
                 <el-select :disabled="(dataFrom =='sqm' &&  child.isSupply == 'N') || editFalg"  v-model="child.importanceProperty" placeholder="请选择">
                      <el-option v-for="optionKey in importancePropertyList" :key="optionKey.valueId" :label="optionKey.valueName" :value="optionKey.valueId+''"></el-option>
                  </el-select>
              </td>
              <td>
                <el-select :readonly="editFalg" :disabled="(dataFrom =='sqm' &&  child.isSupply == 'N')|| editFalg"  v-model="child.checkLevel" placeholder="请选择">
                      <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId" :label="optionKey.valueName" :value="optionKey.valueId+''"></el-option>
                  </el-select>
                <!-- <el-input  v-model="child.checkLevel"  placeholder="请输入内容"></el-input> -->
              </td>

              <td><el-input  v-model="child.aqlProperty" :disabled="(dataFrom =='sqm' &&  child.isSupply == 'N') || editFalg" placeholder="请输入内容"></el-input></td>
              <td v-if="!editFalg">
                <span v-show="!(child.isMust == 'Y' || (dataFrom =='sqm' &&  child.isSupply == 'N'))">
                  <el-popconfirm   title="确定删除吗？"  @confirm="deleteStandard('child',index,'commentList',childIndex)"
                ><template #reference> <i v-show="child.isMust != 'Y'" class="el-icon-delete"></i> </template></el-popconfirm>

                </span>
                 <i class="el-icon-circle-plus-outline" @click="deleteStandard('add',index,'commentList',childIndex)"></i>
                </td>
                <td v-else></td>
            </tr>
        </template>
              <tr >
              <td colspan="2">质量承诺</td>
              <td colspan="6">
                <p class="desc">本公司严格遵守海尔集团公司的工艺、图纸、标准、合同要求，决不随意更改材料、工艺、模具、场地等，由于私自更换而导致的零部件不合格及在生产、社会上造成的对海尔集团公司不利的损失，一切后果由本公司承担；        同时，本公司已对该批零部件进行了严格检验并符合海尔要求，报告（含系统电子版）真实有效，若海尔发现零部件不合格或虚假，本公司愿意按照《质量条款》规定条款接受处罚。
                </p>
                <p class="desc">说明：本模板为参考版，请供应商按照海达源中的图纸、企业标准等依据自主完善，供应商出货检验标准应不低于海尔标准要求。
                  </p>
                   <el-checkbox v-show="dataFrom == 'sqm'" v-model="haseRead" label="1" >我已阅读并同意</el-checkbox>
                  </td>
            </tr>
      </tbody>
    </table>
    <div class="footerBut">
      <el-button v-show="flag == 'edit'  && newadd" size="mini" type="warning" @click="addStandard(-1,'list')">新增检验标准</el-button>
      <el-button  size="mini" @click="goBack()">关 闭</el-button>
      <!-- <el-button  v-show="flag == 'check'"  size="mini" @click="getPdf()">导出为PDF</el-button> -->
      <!-- <el-button :loading="loading" v-show="flag == 'edit'" size="mini" type="primary" @click="submitTemplateCode('暂存')">暂存</el-button> -->
      <el-button :loading="loading" v-show="flag == 'edit'" size="mini" type="warning" @click="submitTemplateCode()">提交</el-button>
      <el-button :loading="loading" v-show="flag == 'audit'" size="mini" type="primary" @click="audit('Y')">同意</el-button>
      <!-- <el-button :loading="loading" v-show="flag == 'audit'" size="mini" type="primary" @click="audit('T')">暂存</el-button> -->
      <el-button :loading="loading" v-show="flag == 'audit'" size="mini" type="primary" @click="audit('N')">不同意</el-button>
    </div>
    <div v-show="flag != 'edit'" style="margin-top:14px">
      <p>审核意见：</p>
      <el-input
        type="textarea"
        :disabled="flag != 'audit'"
        placeholder="请输入"
        v-model="audittextarea">
      </el-input>
    </div>
    <el-dialog
      title="提示"
      v-model="dialogVisible"
      width="70%"
      :before-close="handleClose">
      <div>
        <div class="search-input-label">
          标准编号:
          <el-input
            size="small"
            placeholder="请输入标准编号"
            v-model="input1">
          </el-input>
         <span v-show="manualVisible">
            标准名称:
          <el-input
            size="small"
            placeholder="请输入标准名称"
            v-model="input2">
          </el-input>
         </span>
          <el-button style="margin-left:15px" size="small" type="primary" @click="getTemplateCodeList()">查询</el-button>
          <el-button size="small" type="primary" @click="dealwithStandardList('','manual')" v-show="manualVisible">手动添加</el-button>
        </div>
        <div>
          <el-table
            :data="templateCodeList"  max-height="240"  border size="mini" 
            style="width: 100%">
            <el-table-column prop="templateCode" label="标准编号"> 
               <template #default="scope"><span @click="dealwithStandardList(scope.row,'choice')" style="color:blue;cursor: pointer;">{{scope.row.templateCode}}</span></template>
            </el-table-column>
            <el-table-column prop="templateName" label="标准名称"></el-table-column>
             <!-- <el-table-column
              prop="name"
              label="来源"
              width="180">
            </el-table-column> -->
          </el-table>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dealwithStandardList('close','close')">关 闭</el-button>
          <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<style lang="scss">
  .el-select .el-input.is-disabled .el-input__inner{
    color: #848181;
  }
  .reportTemplate{
    width: 1150px;
    margin: 0px auto;
    height: auto;
    overflow: scroll;
    background: white;
    font-size: 12px;
    padding: 10px;
   
    .lable-left{
      margin-top: 0px;
      padding-right: 20px;
      border-bottom: 1px solid #E5E6E7;
      span{
        font-size: 1.5em;
        line-height: 33px;
        color: #333;
       
      }
      i{
        color: #387CD7;
         padding-right: 10px;
      }
    }
    .lable-header{
      margin: 0px;
      padding-right: 20px;
      font-size: 1.5em;
      line-height: 50px;
      color: #333;
      font-weight: bold;
    }
    table{
      width:100%;
      border-top: 1px solid #ccc;
      border-left: 1px solid #ccc;
      thead{
        color: #000;
        // font-weight: bold;
        font-size: 12px;
      }
      tbody{
        // tr:nth-child(odd){
        //   background: #ecf5ff;
        // }
        .title{
          background: #F8F8F8;
          line-height: 30px;
          text-align: left;
          text-indent: 20px;
          &>span{
            padding-right: 20px;
            padding-left: 10px;
            color: #3a8ee6;
          }
          &>div{
            float: right;
            padding-right: 20px;
          }
    
          .el-button{
            min-height: 20px;
            padding: 3px 15px;
          }
        }
        .desc{
          text-align: left;
          text-indent: 20px;
        }
      }
      td{
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        text-align: center;
         i{
          cursor: pointer;
          padding-right: 10px;
        }
      }
      
    }
     .search-input-label {
      display: inline-block;
      .el-input{
        width: 180px;
      }
      
    }
    .footerBut{
      text-align: center;
      button{
        margin: 10px ;
      }
    }
    .verSIon{
      color: royalblue;
      cursor: pointer;
    }
    .el-input.is-disabled .el-input__inner{
      color: #848181;
    }
  } 
</style>


<script>

export default {
  name: 'ReportTemplate',
  data(){
    return {
      editFalg:false,
      flag:"",
      audittextarea:'',
      dialogVisible: false,
      manualVisible:false,
      selectedIndex:"",
      changeListName:"",
      input1:"",
      input2:"",
      oldMatData:{},
      materData:{
        mtlName: "",
        mtlNo: ""
      },
      haseRead:false,
      commentList:[{
      
        templateId:"通用要求",
        templateCode:"通用要求",
        templateName:"通用要求",
        itemList:[
       
        ]
      }],
      list:[],
      newadd:false,
      templateCodeList: [],
      importancePropertyList:[], // 重要性
      checkLevelList:[],
      dataFrom:"",
      loading:false
    }
  },
  
   methods: {
    // close方法
    closetopwindow(){
      window.top.postMessage("close","*")
      // this.closetopwindow()
    },
     getPdf(){
       pdfDownlod(document.getElementsByClassName("reportTemplate")[0],"出厂检验报告模板.pdf")
     },
     goBack(){
      //  window.print()
      // console.log()
      // pdfDownlod(document.getElementsByClassName("reportTemplate")[0],"出厂检验报告模板.pdf")
       if(this.$route.query.dataFrom == "hmqm"){
          if(this.flag == 'edit' && this.$route.query.dataFromFlag){
            window.history.go(-3)  
              // console.log(window.history)
          }else{
            window.history.go(-1)  
          }
        }else{
           if(this.$route.query.dataFromFlag == 'close'){
              this.closetopwindow()
            }else{
              window.history.go(-1)
            }
          // window.history.go(-1)  
        }
     },
     //跳转历史版本页
     goHistory(){
       this.$router.push({path:"/histortReportList",query:{
         version:this.materData.version,
         mtlNo:this.materData.mtlNo,
         dataFrom:this.dataFrom,
         supplyCode:this.supplyCode|| this.materData.supplyCode
       }})
     },
     //  关闭弹窗
      handleClose(done) {
         done();
      },
      /**
       * @description:  新增检验标准弹窗
       * @param {*} index  用来记录需要添加标准的下标
       * @param {*} listType  需要处理的文件
       * @return {*}
       */
      addStandard(index,listType){
        this.selectedIndex = index;
        this.changeListName = listType;
        this.dialogVisible = true;
        if(listType == "commentList"){
          this.manualVisible = true
        }
      },
      manualStandard(){           
                                 
      },
      dealwithStandardList(item,flag){
        this.dialogVisible=false;
        this.manualVisible= false;
        this.templateCodeList = [];
        if(flag == 'choice'){ // 弹窗选择 
          let _this = this;
          this.$http({
              method: 'get',
              url: `/unload/item/list/${item.templateId}`,
              // headers: { 'content-type': 'application/x-www-form-urlencoded' },
              params: {
                supplyCode:this.supplyCode
              },
          }).then((res)=>{
            if(res.status==200 && res.data.code == 1){
              let itemList=[...res.data.data]
              for(let i = 0; i < itemList.length; i++){
                itemList[i].isSupply = 'N'
              }
              if(!itemList.length){
               itemList[0] = {
                  itemId:Math.random(),
                  itemName:"",
                  remark:"",
                  importanceProperty:"",
                  checkLevel:"",
                  aqlProperty:"",
                  templateType:"N",
                  isSupply:this.isSupply,
                }

              }
              // let item = unload/item/list/99900674
              this[this.changeListName].splice(this.selectedIndex+1,0,{...item,templateType:"N",itemList})
            }
          });
        }else if(flag == "manual"){ // 手动输入
          let input1 = this.input1;
          let input2 = this.input2;
          if(!input2){
            this.$alert('自定义标准名称为必填项', '提示', {
                  confirmButtonText: '确定',
            })
            return 
          }
          this.list.splice(this.selectedIndex+1,0,{
            templateId:Math.random(),
            templateCode:input1,
            templateName:input2,
            flag:"manual",
            templateType:"N",
            itemList:[
              {
                itemId:Math.random(),
                itemName:"",
                remark:"",
                importanceProperty:"",
                checkLevel:"",
                aqlProperty:"",
                templateType:"N",
                isSupply:this.isSupply,
              }
            ]})
          this.input1 = "";
          this.input2 = "";
        }
        this.newadd = false
      },
      /**
       * @description: 删除标准或添加子项目
       * @param {*} type   parent 删除整个标准  child 删除标准的某一项
       * @param {*} index  标准的角标
       * @param {*} listType  需要删除的数组
       * @param {*} childIndex  标准的具体项
       * @return {*}
       */
      deleteStandard(type,index,listType,childIndex){
        switch (type){
          case "parent" :
            this[listType].splice(index,1)
            break
          case "child":
             this[listType][index].itemList.splice(childIndex,1)
            break
          case "add":
            let templateType = ""
            if(listType == "list" && this[listType][index].flag == "manual"){
              templateType = "N"
            }
            this[listType][index].itemList.splice(childIndex+1,0,{ itemId:Math.random(),
                itemName:"",
                remark:"",
                importanceProperty:"",
                checkLevel:"",
                aqlProperty:"",
                isSupply:this.isSupply,
                templateType})
            break
        }
        console.log(this.list,'list')
        if(this.list.length == 0 ){
          this.newadd = true
        } else {
          this.newadd = false
        }
      },
      // 根据专用号查询物料信息
      getMatName(mtlNo){
        this.$http({
            method: 'get',
            url: '/unload/mkl/info',
            // headers: { 'content-type': 'application/x-www-form-urlencoded' },
            params: {...mtlNo},
        }).then((res)=>{
          if(res.status==200 && res.data.code == 1){
            this.materData={
              ...res.data.data
            }
            this.audittextarea = res.data.data.auditOpinion
            if(res.data.data.shipmentId){
              this.haseRead = true
            }
          }
         
        });
      },
       //unload/common/list 
      getCommonTemplateList(mtlNo){
          this.$http({
            method: 'get',
            url: '/unload/common/list',
            // headers: { 'content-type': 'application/x-www-form-urlencoded' },
            params: {...mtlNo,shipmentTemplateId:this.shipmentId},
        }).then((res)=>{
          if(res.status==200 && res.data.code == 1){
            if(res.data.data && res.data.data.length){

              this.commentList[0].itemList = res.data.data
            }
          }
         
        });
      },
      //unload/item/list  
      getTemplateList(mtlNo){
          this.$http({
            method: 'get',
            url: '/unload/item/list',
            // headers: { 'content-type': 'application/x-www-form-urlencoded' },
            params: {...mtlNo},
        }).then((res)=>{
          if(res.status==200 && res.data.code == 1){
            if(res.data.data && res.data.data.length){
              this.list = res.data.data
              this.newadd = false
            } else {
              this.newadd = true
            }
            
          }else{
            //请先由海尔工厂外检创建完成专用号检验依据，才可以发起创建出厂模板流程。
            this.$alert('请先由海尔工厂外检创建完成专用号检验依据，才可以发起创建出厂模板流程。', '提示', {
                  confirmButtonText: '确定',
                  callback:action=>{
                    this.goBack();
                  }
            })
          }
         
        });
      },
      // 根据专用号查询物料信息
      getTemplateCodeList(){
        let _this= this;
        this.$http({
            method: 'get',
            url: '/unload/template/list',
            // headers: { 'content-type': 'application/x-www-form-urlencoded' },
            params: {templateCode:_this.input1},
        }).then((res)=>{
          if(res.status==200 && res.data.code == 1){
            if(res.data.data && res.data.data.length>0){
              this.manualVisible = false;
            }else{
              this.manualVisible  = true;
            }
            this.templateCodeList=[...res.data.data]
          }
         
        });
      },
      // 保存模板
      submitTemplateCode(){
        if((!this.haseRead) && this.dataFrom == 'sqm'){
           this.$alert('请阅读质量承诺，并选择已阅读并同意', '提示', {
                  confirmButtonText: '确定',
            })
            return 
        }
        let _this= this;
        /*  this.oldMatData={
              oldSupplyCode:this.$route.query.oldSupplyCode,
              sybId:this.$route.query.sybId,
              createFactory:this.$route.query.createFactory,
              sysSource:this.$route.query.sysSource
            } */
        let oldData = {

        }
        if(this.oldMatData.sysSource){
          oldData.supplyCode = this.oldMatData.oldSupplyCode;
          oldData.sybId = this.oldMatData.sybId;
          oldData.createFactory = this.oldMatData.createFactory;
          oldData.dataFrom = this.oldMatData.sysSource;
          if(this.dataFrom == 'sqm'){
             oldData.auditFactory =  oldData.createFactory;
            oldData.createFactory = window.getItemName;
            oldData.sybId=this.$route.query.sybId;
          }
          // 新增老品时 供应商端 将审核工厂的名字 放到auditFactory中， createFactory中存入当前供应商的名字
          // hmqm端  createFactory 存入选择的发起方工厂 无 auditFactory
        }
        // 变更添加逻辑 hmqm端传入dataFrom = "海尔" sqm端传入 dataFrom = "供应商"
        if(this.oldMatData.sysSourceChange){
          oldData.dataFrom = this.oldMatData.sysSourceChange;
          oldData.sybId=this.$route.query.sybId;
        }

        for(let i = 0; i <_this.list.length; i++){
          if(_this.list[i].itemList){
            for(let j = 0; j <_this.list[i].itemList.length; j++){
              let item = _this.list[i].itemList[j];
              if(!item.itemName|| !item.remark|| !item.importanceProperty|| !item.checkLevel|| !item.aqlProperty){
                // itemName remark importanceProperty checkLevel aqlProperty
                
                 this.$alert(`该${_this.list[i].templateName}检验标准下，第${j+1}条数据存在数据未填写`, '提示', {
                  confirmButtonText: '确定',
                  })
                  return 
              }
            }
          }
        }
        // 
        if(_this.commentList[0].itemList){
            for(let j = 0; j <_this.commentList[0].itemList.length; j++){
              let item = _this.commentList[0].itemList[j];
              if(!item.itemName|| !item.remark|| !item.importanceProperty|| !item.checkLevel|| !item.aqlProperty){
                // itemName remark importanceProperty checkLevel aqlProperty
                
                 this.$alert(`通用要求中第${j+1}条数据存在数据未填写`, '提示', {
                  confirmButtonText: '确定',
                  })
                  return 
              }
            }
          }
        if(this.dataFrom == 'sqm' && this.$route.query.flag == 'edit'){
          oldData.sybId=this.$route.query.sybId;
          oldData.auditFactory=this.$route.query.auditFactory;
        }
        let paramData={
          status:this.$route.query.changeStatus || "N",
          shipmentId:this.shipmentId || '',
          ..._this.materData,
          itemList:[..._this.list],
          commonItemList:this.commentList[0].itemList,
          ...oldData,
          createFactory:this.$route.query.createFactory,
          name:this.$route.query.name,
          nickName:this.$route.query.nickName,
        }
        // if(a =='暂存'){
        //   paramData.status = 'T'
        // }
        console.log(paramData,'paramData')
        if(typeof(paramData.supplyCode)=='string'){
          paramData.supplyCode = [paramData.supplyCode]
        }
        this.loading = true;
        // return
        this.$http({
            method: 'post',
            url: '/unload/item/add',
            data: {
             ...paramData
            },
        }).then((res)=>{
          console.log(res,'res')
          this.loading = false;
          if(res.status==200 && res.data.code == 1){
            
            this.$alert('操作成功', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                       // hmqm进入需要后退三步
                        if(this.$route.query.dataFrom == "hmqm"){
                          if(this.flag == 'edit' && this.$route.query.dataFromFlag){
                            window.history.go(-3)  
                          }else{
                            // 新增出货模板
                            window.history.go(-1) 
                          }
                        }else if(this.$route.query.dataFrom == "sqm"){
                          if(this.$route.query.dataFromFlag == 'close'){
                            this.closetopwindow()
                          }else{
                            window.history.go(-1)
                          }
                          
                          // window.close();
                        }else{
                          window.history.go(-1) 
                        }

                       
                    }
                })
            if(res.data.data && res.data.data.length){
              // this.manualVisible = true;
            }
            // this.templateCodeList=[...res.data.data]
          } else if(res.data.code == '0'){
            this.$alert(res.data.msg, '提示', {
                  confirmButtonText: '确定',
            })
          }
         
        });
      },
      audit(flag){
        if(this.audittextarea == "" ||this.audittextarea == null || this.audittextarea == undefined  ){
          this.$alert('请填写审核意见后再提交')
          return false
        }
        let _this = this;
        this.loading = true;
        this.$http({
          method: 'post',
          url: '/unload/audit/item',
          // headers: { 'content-type': 'application/x-www-form-urlencoded' },
          data: {shipmentId:this.shipmentId,status:flag,auditOpinion:this.audittextarea}, // Y:审核通过；N:审核不通过
        }).then((res)=>{
             this.loading = false
          if(res.status==200 && res.data.code == 1){
             this.$alert('审核成功', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                      window.history.go(-1)
                      // if(this.$route.query.dataFrom == "hmqm"){
                        
                      // }else if(this.$route.query.dataFrom == "sqm"){
                      //   window.close();
                      // }else{
                      //   window.history.go(-1)
                      // }
                        // window.location = "http://10.190.176.71:8085/newproduct/materialCod?pageNo=&pageSize=&mtlNo=0020812222J&mtlName=&queryFlag=T&beginDateOne=&endDateOne="
                    }
                })
           
          } else if (res.status == 200 && res.data.code == '0') {
            this.$alert( res.data.msg , '信息提示', {
              confirmButtonText: '确定',
              callback: action => {
                window.history.go(-1)
              }
            })
          }
         
        });
      },
      getBaseList(type,listKey){
        // 
        this.$http({
            method: 'get',
            url: '/unload/base/list',
            params: {
             type,
             supplyCode:this.supplyCode
            },
        }).then((res)=>{
          if(res.status==200 && res.data.code == 1){
         
            if(res.data.data && res.data.data.length){
              // this.manualVisible = true;
              this[listKey] = res.data.data
            }
            
          }
         
        });
      }

    },
    mounted(){
        let querySearch = {}
        console.log(this.$route.query,'上一个页面传过来的信息')
        // this.searchData = JSON.parse(this.$route.query.searchData);
        // console.log(this.searchData)
        // console.log(obj2)
        if(this.$route.query){
          
           if(this.$route.query.supplyCode){
            this.supplyCode = this.$route.query.supplyCode
          }
           if(this.$route.query.name){
            // localStorage.setItem("name",this.$route.query.name);
            // localStorage.setItem("nickName",this.$route.query.nickName)
             window.getItemName = this.$route.query.name
             window.getItemNickName = this.$route.query.nickName
            }
            if(this.$route.query.flag){
              if(this.$route.query.flag != 'edit'){
                this.editFalg = true
                this.haseRead = true
              }
              
              this.flag = this.$route.query.flag
            }
             if(this.$route.query.dataFrom){
              this.dataFrom = this.$route.query.dataFrom
              if(this.$route.query.dataFrom != 'sqm'){
                this.isSupply = "N"
              }else{
                this.isSupply = "Y"
              }
            }
             this.shipmentId = this.$route.query.shipmentId
            querySearch= {mtlNo:this.$route.query.mtlNo,version:this.$route.query.versionNo,supplyCode:this.$route.query.supplyCode}
            if(this.$route.query.sysSource){
              /* 
              oldSupplyCode:this.oldItem.supplyCode,
              sybId:this.oldItem.factoryCode.valueId,
              createFactory:this.oldItem.factoryCode.valueName,
              sysSource:"sqm"
             */
              this.oldMatData={
                oldSupplyCode:this.$route.query.oldSupplyCode,
                sybId:this.$route.query.sybId,
                createFactory:this.$route.query.createFactory,
                sysSource:this.$route.query.sysSource
              }
              if(typeof(this.oldMatData.oldSupplyCode)=='string'){
                querySearch.supplyCode = this.oldMatData.oldSupplyCode
              }else {
                querySearch.supplyCode = this.oldMatData.oldSupplyCode[0]
              }
              
            }

            if(this.$route.query.sysSourceChange){
              this.oldMatData={
                sysSourceChange:this.$route.query.sysSourceChange
              }
            }
           
            this.getMatName(querySearch);
            this.getTemplateList(querySearch);
            this.getCommonTemplateList(querySearch);
            
          }
         // 
         this.getBaseList(13,"importancePropertyList") 
         this.getBaseList(14,"checkLevelList") 
    
    }
       
}
        if(window.location.search){
            let search= window.location.search
            window.location.replace("/#/reportTemplate"+search)
        }
</script>
